import { notifyError } from "common/utils/app-monitoring/notify";

// Fill related places (deliver-to toggle + modal field) with the selected
// address. Header sync is best-effort — the zipcode is already persisted
// server-side and the dates section has already been refreshed by the caller,
// so a failure here must never surface to the user. The MN-2852 clean-load race
// (null modal input) is guarded at its source in
// DeliverToZipCodeFormClass#fillZipCodeField, so any error that still reaches
// this catch is unexpected and gets reported rather than swallowed silently.
const syncDeliverToHeader = ({ zipcode, city }) => {
  try {
    window.JiffyDeliverTo?.updateZipCodeInHeader({ zipcode, city });
  } catch (error) {
    notifyError(error);
  }
};

export default syncDeliverToHeader;
